import { Component, OnInit, inject } from '@angular/core';
import { CardComponent } from '../../../../shared/components/card/card.component';
import { IconComponent } from '../../../../shared/icons/icon.component';
import { TextWithIconComponent } from '../../../../shared/components/text-with-icon/text-with-icon.component';
import { TranslatePipe } from '@ngx-translate/core';
import { selectUnreadErrorNotifications } from '../../state/notification.selectors';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';
import { AsyncPipe } from '@angular/common';
import { NotificationActions } from '../../state/notification.actions';
import { RouterLink } from '@angular/router';
import { RouteConstants } from '../../../../shared/constants/route-constants';
import { NotificationLevel } from '@birco/rainmesh-api';
import { RuleNamePipe } from '../../../rules/pipes/rule-name.pipe';

@Component({
  selector: 'app-notifications-dashboard-card',
  imports: [
    CardComponent,
    IconComponent,
    TextWithIconComponent,
    TranslatePipe,
    AsyncPipe,
    RouterLink,
    RuleNamePipe,
  ],
  templateUrl: './notifications-dashboard-card.component.html',
  styleUrl: './notifications-dashboard-card.component.scss',
})
export class NotificationsDashboardCardComponent implements OnInit {
  private store = inject(Store);

  data$ = this.store.select(selectUnreadErrorNotifications).pipe(
    map((v) => ({
      hasErrors: v.length > 0,
      notificationList: v,
    })),
  );

  ngOnInit() {
    this.store.dispatch(
      NotificationActions.public.loadUnreadErrorNotifications(),
    );
  }

  protected readonly RouteConstants = RouteConstants;
  protected readonly NotificationLevel = NotificationLevel;
}
